import { addToCart, updateCart } from '../lib/cart';
import { getMtoDeliveryDate } from '~/js/lib/date';

export default (node) => {
  let quantityIsUpdating = false;

  const itemKey = node.dataset.cartItem;
  const quantityButtons = node.querySelectorAll('[data-quantity-button]');
  const removeButton = node.querySelector('[data-remove-item]');
  const quantityNode = node.querySelector('[data-quantity-value]');
  const mtoDeliveryDateNode = node.querySelector('[data-mto-delivery-date]');
  const giftWrappingButton = node.querySelector('[data-gift-wrapping-button]');

  const isWrappingItemKey = node.dataset.isWrappingItemKey;
  const wrappingItemQuantity = node.dataset.wrappingItemQuantity;

  let quantity = quantityNode.dataset.quantityValue;

  const handleQuantityButtonClick = async (button) => {
    // Prevent multiple clicks from updating the quantity multiple times
    if (quantityIsUpdating) {
      return;
    }

    quantityIsUpdating = true;

    const buttonType = button.dataset.quantityButton;

    if (buttonType === 'add') {
      quantity++;
    } else if (buttonType === 'subtract') {
      quantity = quantity <= 1 ? 0 : quantity - 1;
    }

    if (quantity !== 0) {
      quantityNode.textContent = quantity;
    }

    const items = { [itemKey]: quantity };

    // If item has a wrapping item, the quantity should not be greater than
    // the primary item quantity
    if (
      isWrappingItemKey &&
      wrappingItemQuantity &&
      quantity < wrappingItemQuantity
    ) {
      items[isWrappingItemKey] = quantity;
    }
    await updateCart(items);

    quantityIsUpdating = false;
  };

  const removeItem = () => {
    const items = { [itemKey]: 0 };

    // Remove wrapping item if it exists
    if (isWrappingItemKey) {
      items[isWrappingItemKey] = 0;
    }
    updateCart(items);
  };

  const setMtoDeliveryDate = () => {
    const deliveryTime = Number(mtoDeliveryDateNode.dataset.deliveryTime);
    const string = mtoDeliveryDateNode.dataset.string;
    const weekString = mtoDeliveryDateNode.dataset.weekString;
    const region = mtoDeliveryDateNode.dataset.region;

    const mtoDeliveryDate = getMtoDeliveryDate(
      deliveryTime,
      string,
      weekString,
      region
    );

    mtoDeliveryDateNode.textContent = mtoDeliveryDate;
  };

  const handleGiftWrappingButtonClick = () => {
    const giftWrappingOptionId =
      giftWrappingButton.dataset.giftWrappingOptionId;

    if (giftWrappingOptionId) {
      addToCart([
        {
          id: Number(giftWrappingOptionId),
          quantity: quantity,
          properties: {
            _lineKey: itemKey,
          },
        },
      ]);
    }
  };

  const init = () => {
    if (quantityButtons.length > 0) {
      quantityButtons.forEach((button) =>
        button.addEventListener('click', () =>
          handleQuantityButtonClick(button)
        )
      );
    }

    if (removeButton) {
      removeButton.addEventListener('click', removeItem);
    }

    if (mtoDeliveryDateNode) {
      setMtoDeliveryDate();
    }

    if (giftWrappingButton) {
      giftWrappingButton.addEventListener(
        'click',
        handleGiftWrappingButtonClick
      );
    }
  };

  init();
};
